import React from 'react';
import styled from 'styled-components';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';
import { DocGrid, GridItem } from '../../../components/Styled/grids/editorGrid';

const ThisDocGrid = styled(DocGrid)`
  grid-template-areas:  "name";
  
  @media (max-width: 600px) {
  display: block;
  }
`;

const editorRenderer = (getControl) => (
  <ThisDocGrid>
    <GridItem area="name">
      {getControl('code')}
      {getControl('name')}
    </GridItem>
  </ThisDocGrid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/provinces/', CommandPanels.catCommandPanel);
